<template>
  <div class="panel__col">
    <p class="panel__title">
      {{ label }}
    </p>
    <p v-if="filter === 'cpf'">
      <input
        :readonly="!enable"
        class="form-control"
        v-mask="'###.###.###-##'"
        :value="value"
        @input="emitInputed($event)"
      >
    </p>
    <p v-else-if="filter === 'gender'">
      <select :disabled="!enable" class="form-control" :value="value" @input="emitInputed($event)">
        <option v-for="(option, index) in options" :value="option.value" :key="index">
          {{ option.label }}
        </option>
      </select>
    </p>
    <p v-else-if="filter === 'birth'">
      <input
        :readonly="!enable"
        class="form-control"
        v-mask="'##/##/####'"
        :value="value"
        @input="emitInputed($event)"
      >
    </p>
    <p v-else-if="filter === 'marital'">
      <select :disabled="!enable" class="form-control" :value="value" @input="emitInputed($event)">
        <option v-for="(option, index) in options" :value="option.value" :key="index">
          {{ option.label }}
        </option>
      </select>
    </p>
    <p v-else-if="filter === 'phone'">
      <input
        :readonly="!enable"
        class="form-control"
        v-mask="'(##) #####-####'"
        :value="value"
        @input="emitInputed($event)"
      >
    </p>
    <p v-else-if="filter === 'email'">
      <input
        :readonly="!enable"
        class="form-control"
        type="email"
        :value="value"
        @input="emitInputed($event)"
      >
    </p>
    <div v-else-if="filter === 'currency'">
      <money-input :readonly="!enable" class="form-control" :value="value" @input="emitInputed($event)" />
    </div>
    <span
      v-else-if="badge == true"
      class="badge badge-circle"
      :class="{ 'badge-danger': isDanger, 'badge-warning': isWarning, 'badge-sucess': isSucess }"
    >
      {{ badgeText }}
    </span>
    <p v-else class="panel__value">
      <textarea
        rows="1"
        :readonly="!enable"
        class="form-control textarea"
        type="text"
        :value="value"
        @input="emitInputed($event)"
      ></textarea>
    </p>
  </div>
</template>
<style lang="scss" scoped>
  .panel__value {
    word-break: break-all;
  }
  .badge {
    min-height: 16px;
    min-width: 16px;
    font-size: 13px;
    margin-bottom: 3px;
  }
  .badge-danger {
    background-color: #FF0000;
  }
  .badge-warning {
    background-color: #DEBF00;
  }
  .badge-sucess {
    background-color: #008000;
  }
  .textarea {
    resize: none;
  }
</style>
<script>
import MoneyInput from './MoneyInput';

export default {
  components: {
    MoneyInput,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    filter: {
      type: String,
      default: '',
    },
    enable: {
      type: Boolean,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    badgeText: {
      type: String,
      default: '',
    },
    badge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDanger() {
      return ['reproved', 'documents_reproved'].includes(this.value);
    },
    isWarning() {
      return [
        'waiting_enrollment',
        'offer_completed',
        'data_completed',
        'documents_in_analysis',
      ].includes(this.value);
    },
    isSucess() {
      return ['waiting_enrollment', 'documents_approved', 'approved'].includes(this.value);
    },

  },
  methods: {
    emitInputed($event) {
      if (!$event || !$event.target) return;
      this.$emit('inputed', $event.target.value);
    },
  },
};
</script>
